export const capitalize = (s) => {
  if (typeof s !== 'string') {
    throw new TypeError(`${typeof s} is not a string`);
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
};
